export default __webpack_public_path__ + "static/media/193.2612b044.png";